/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Heading2Inputs */

const zh_landing_pricing_heading2 = /** @type {(inputs: Landing_Pricing_Heading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`随你一起成长`)
};

const en_landing_pricing_heading2 = /** @type {(inputs: Landing_Pricing_Heading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`scales with you`)
};

const es_landing_pricing_heading2 = /** @type {(inputs: Landing_Pricing_Heading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`crecen contigo`)
};

/**
* | output |
* | --- |
* | "scales with you" |
*
* @param {Landing_Pricing_Heading2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_pricing_heading2 = /** @type {((inputs?: Landing_Pricing_Heading2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Heading2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_pricing_heading2(inputs)
	if (locale === "en") return en_landing_pricing_heading2(inputs)
	return es_landing_pricing_heading2(inputs)
});